import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import ResponsiveReservation from '../../responsiveReservation/responsiveReservation'
import { EMPTY_ARRAY, EMPTY_OBJECT } from '../../../constants/globalConstants'
// import {  EMPTY_OBJECT } from '../../../constants/globalConstants'

import { getPassUserDetails } from '../../../redux/actions/bookingHistoryAction'
import { Circles } from 'react-loader-spinner'
import {isPermissionExist,sortPortalPermissionByKey} from '../../../utils/helper'


function BookingEdit(props) {
    const { dispatch, notify ,partnerDetails} = props
    const [bookingDatabyID, setBookingDataById] = useState(EMPTY_OBJECT)
    const partnerData = JSON.parse(localStorage.getItem('partnerData'))
    const url = window.location.toString().split('/')
    const encriptedKey = url[url?.length - 1]
  const [isLoading, setIsLoading] = useState(true)
  const [accessPermissions, setAccessPermissions] = useState('')

    // && partnerData?.clients?.secret!==''
    useEffect(() => {
        if (encriptedKey && encriptedKey !== '' && encriptedKey !== null && encriptedKey !== undefined && partnerDetails?.id) {

            dispatch(getPassUserDetails(encriptedKey)).then((res) => {
                setIsLoading(false)
                setBookingDataById(res)
            })
        }
    }, [partnerDetails])

    useEffect(() => {
        const getAccessPermissionData = sortPortalPermissionByKey(partnerDetails, 'Restricted Permissions')
        setAccessPermissions(getAccessPermissionData)
      }, [EMPTY_ARRAY, partnerDetails])


    return (isLoading)
        ? <span className='ms-2 d-flex justify-content-center'><Circles height="500" width="50" color="var(--bs-primary)" ariaLabel="circles-loading" visible={true} /></span>
        : isPermissionExist(accessPermissions, 'Reservation Booking Edit') ?
        <ResponsiveReservation partnerDetails={partnerData} notify={notify} BookingEditData={bookingDatabyID} BookingEdit={isPermissionExist(accessPermissions, 'Reservation Booking Edit')} />
        : <div className='container mt-2 min-h-box noform' id="qbox-container">
            <h4 className="my-4 text-center titleHeading text-danger"><i className='fa fa-warning'></i> Edit Reservation Permission Denied!</h4>

        </div>
       
    }

BookingEdit.propTypes = {
    dispatch: PropTypes.func,
    loader: PropTypes.bool,
    notify: PropTypes.func,
    partnerDetails: PropTypes.object,
}

BookingEdit.defaulProps = {
    dispatch: noop,
    loader: false,
    notify: noop,
    partnerDetails: EMPTY_OBJECT,
}

function mapStateToProps({ bookingHistoryReducer }) {
    return {
        loader: bookingHistoryReducer?.loader
    }
}
export default connect(mapStateToProps)(BookingEdit)